<!--
커뮤니케이션 감시 컴포넌트
-->
<template>
    <i class="material-icons icon" :class="iconState" @click="change">{{ iconName }}</i>
</template>

<script>
    export default {
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },
            /**
             * 커뮤니케이션ID
             */
            cmId: {
                type: Number,
                required: true,
            },
            /**
             * 감시자로 설정할 사용자ID
             */
            userId: {
                type: Number,
                required: true,
            },
            /**
             * 감시여부
             */
            watchInit: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                // (bool) ajax 처리중 여부
                ajaxing: false,

                // (bool) 감시여부*/
                watch: this.watchInit,
            };
        },
        computed: {
            /**
             * 아이콘 이름
             */
            iconName() {
                if (this.ajaxing) {
                    return 'hourglass_empty';
                } else if (this.watch) {
                    return 'visibility';
                } else {
                    return 'visibility_off';
                }
            },

            /**
             * 상태
             */
            iconState() {
                if (this.ajaxing) {
                    return 'ajaxing';
                } else if (this.watch) {
                    return 'watch';
                } else {
                    return 'none';
                }
            },
        },
        methods: {
            /**
             * 감시중 상태 변경
             */
            change() {
                // 처리중인지
                if (this.ajaxing) {
                    return;
                }

                // 처리 시작
                this.ajaxing = true;

                let p = null;
                if (this.watch) {
                    p = this.off();
                } else {
                    p = this.on();
                }

                p.then((watch) => {
                    this.watch = watch;
                }).finally(() => {
                    this.ajaxing = false;
                });

            },

            /**
             * ON
             * @return Promise
             */
            on() {
                const watch = true;
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/communications/' + this.cmId + '/on-watch',
                        //contentType: 'application/json',
                        data: {
                            '_token': this.csrfToken,
                            'user_id': this.userId,
                        },
                        success: (response, textStatus, jqXHR) => {
                            resolve(watch);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);

                });
            },

            /**
             * OFF
             * @return Promise
             */
            off() {
                const watch = false;
                return new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/communications/' + this.cmId + '/off-watch',
                        //contentType: 'application/json',
                        data: {
                            '_token': this.csrfToken,
                            'user_id': this.userId,
                        },
                        success: (response, textStatus, jqXHR) => {
                            resolve(watch);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .icon {
        font-size: 1.5rem;

        // 텍스트 선택막기
        -ms-user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
    }
    .ajaxing {
        color: #0f7ae5;
    }
    .watch {
        color: #000;
    }
    .none {
        color: #999;
    }
</style>